import React, { useEffect, useState } from 'react';
import FormPage from '../../../../shared/Layout/FormPage';
import CustomCard, { CustomGridLayout } from '../../../../shared/Cards/CustomCard';
import formValidation from '../../../../utils/validations';
import {
    CustomCalenderInput,
    CustomDropDown,
    CustomInput,
    CustomInputDecimalNumber,
    CustomInputDropDown,
    CustomInputNumber,
    CustomInputSwitch,
} from '../../../../shared/Input/AllInputs';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
    afterSixPaymentsOptions,
    autoPayOptions,
    intervalOptions,
    oftenClientChargedOptions,
    whenClientChargedOptions,
    yesNoOptions,
} from '../../../../utils/dropdownConstants';
import PrimaryButton, { CustomButtonGroup, LightButton } from '../../../../shared/Button/CustomButton';
import CustomPickList from '../../../../shared/Input/CustomPickList';
import AddServices from '../../Inventory/CatalogItems/AddServices';
import CustomEditor from '../../../../shared/Input/CustomEditor';
import { showFormErrors } from '../../../../utils/commonFunctions';
import {
    addMembershipPlan,
    editMembershipPlan,
    editServiceFee,
    getMembershipPlan,
} from '../../../../redux/actions/Settings/AgreementSetup/agreementPlanAction';
import useGetClubs from '../../../../hooks/useGetClubs';
import { getMembersipTypes } from '../../../../redux/actions/Settings/MembershipSetup/membershipTypeAction';
import { getAssesedFees } from '../../../../redux/actions/Settings/AgreementSetup/assessedFeeAction';
import { getAgreementTemplates } from '../../../../redux/actions/Settings/AgreementSetup/AgreementTemplateAction';
import { getAgreementCategories } from '../../../../redux/actions/Settings/AgreementSetup/agreementCategoriesAction';
import CustomDialog from '../../../../shared/Overlays/CustomDialog';
import EditableListTable from '../../../../shared/EditableListTable/EditableListTable';
import CustomMultiSelectEditable from '../../../../shared/Input/CustomMultiSelectEditable';
import { getCatalogItems } from '../../../../redux/actions/Settings/InventorySetup/catalogItemsAction';

const AgreementPlanForm = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { id } = useParams();
    const loading = useSelector((state) => state.loader.isLoading);
    const [loader, setLoader] = useState(false);
    const [open, setOpen] = useState(false);

    const [data, setData] = useState({
        category: '',
        subCategory: '',
        club: '',
        name: '',
        membershipType: '',
        agreementTemplate: '',
        isOneTimePlan: true,
        assessedFee: [],
        services: [],
        autoPay: 'ON_SET_SCHEDULE',
        howOftenWillClientsBeCharged: 'MONTH_TO_MONTH',
        timePeriod: 1,
        interval: 'months',
        noOfAutopays: '',
        whenWillClientsBeCharged: 'ON_SALE_DATE',
        date: '',
        whatHappensAfterAutopayPayments: 'CONTRACT_EXPIRES',
        sellOnline: '',
        onlineDescription: '',
        agreementPlans: [],
        reavailableAfter: {
            value: '1',
            type: 'YEAR',
        },

        freezingTerm: {
            value: '1',
            type: 'MONTH',
        },
        cancellingTerm: {
            value: '1',
            type: 'MONTH',
        },
        reavailableAfterPeriod: 'YEAR',
        isActive: true,
    });

    const [serviceData, setServiceData] = useState({});

    useEffect(() => {
        dispatch(getAgreementCategories());
        dispatch(getMembersipTypes());
        dispatch(getAssesedFees());
        dispatch(getAgreementTemplates());
        dispatch(getCatalogItems());
    }, [dispatch]);

    const { catalogServiceFilterItems } = useSelector((state) => state.catalogItems);
    const allAssessedFeesDropdown = useSelector((state) => state.settings.agreement.assessedFeesDropdown);
    const agreementTemplatesDropdown = useSelector((state) => state.settings.agreement.agreementTemplatesDropdown);
    let { agreementCategoriesDropdown, agreementCategories } = useSelector((state) => state.settings.agreement);

    const [subcategoryOptions, setSubcategoryOptions] = useState([]);
    const MembershipTypesDropdown = useSelector((state) => state.settings.members.membershipTypesDropdown);
    const { clubsDropdown } = useGetClubs();

    const handleSave = () => {
        let ignore = ['services'];
        if (data?.whenWillClientsBeCharged !== 'SPECIFIC_DATE') {
            ignore = [...ignore, 'date'];
        }
        if (showFormErrors(data, setData, ignore)) {
            data.services = data.services.map((item) => {
                item.service = item._id;
                return item;
            });
            if (id) {
                dispatch(editMembershipPlan(id, data, history));
            } else {
                dispatch(addMembershipPlan(data, history));
            }
        }
    };
    const handleChange = ({ name, value }) => {
        const formErrors = formValidation(name, value, data);
        if (name === 'category') {
            setData((prev) => ({ ...prev, [name]: value, formErrors }));
            const subCategory =
                agreementCategories.find((category) => category._id === value)?.subCategories?.map((item) => ({ name: item, value: item })) || [];
            setSubcategoryOptions(subCategory);
        }
        setData((prev) => ({ ...prev, [name]: value, formErrors }));
    };

    const fetchMembershipPlan = () => {
        dispatch(
            getMembershipPlan(id, null, (data) => {
                setData({
                    category: data.category,
                    subCategory: data.subCategory,
                    club: data.club,
                    name: data.name,
                    membershipType: data?.membershipType?._id,
                    agreementTemplate: data.agreementTemplate,
                    assessedFee: data?.assessedFees?.map((item) => item._id),
                    services: data.services,
                    autoPay: data.autoPay,
                    howOftenWillClientsBeCharged: data.howOftenWillClientsBeCharged,
                    timePeriod: data.timePeriod,
                    interval: data.interval,
                    noOfAutopays: data.noOfAutopays,
                    whenWillClientsBeCharged: data.whenWillClientsBeCharged,
                    date: data.date,
                    whatHappensAfterAutopayPayments: data.whatHappensAfterAutopayPayments,
                    sellOnline: data.sellOnline,
                    onlineDescription: data.onlineDescription,
                    isOneTimePlan: data.isOneTimePlan,
                    agreementPlans: data.agreementPlans,
                    reavailableAfter: data.reavailableAfter,
                    reavailableAfterPeriod: data.reavailableAfterPeriod,
                    isActive: data.isActive,
                });
                const subCategory =
                    agreementCategories.find((category) => category._id === data.category)?.subCategories?.map((item) => ({ name: item, value: item })) || [];
                setSubcategoryOptions(subCategory);
            }),
        );
    };

    useEffect(() => {
        if (id) {
            fetchMembershipPlan();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, dispatch]);

    const handleServiceSave = () => {
        setLoader(true);
        const apiPayload = {
            services: [serviceData],
        };

        dispatch(
            editServiceFee(serviceData._id, apiPayload, () => {
                setOpen(false);
                setServiceData({});
                setLoader(false);
                fetchMembershipPlan();
            }),
        );
    };

    console.log('catalogServiceFilterItems=>', catalogServiceFilterItems);

    return (
        <>
            <FormPage backText="Agreement Plan">
                <CustomCard col="12" title="General">
                    <CustomGridLayout>
                        <CustomDropDown name="category" options={agreementCategoriesDropdown} onChange={handleChange} data={data} required />
                        <CustomDropDown name="subCategory" options={subcategoryOptions} onChange={handleChange} data={data} required />
                        <CustomInput name="name" data={data} onChange={handleChange} required />
                        <CustomDropDown name="club" options={clubsDropdown} onChange={handleChange} data={data} required />
                        <CustomDropDown name="membershipType" options={MembershipTypesDropdown} onChange={handleChange} data={data} required />
                        <CustomDropDown name="agreementTemplate" options={agreementTemplatesDropdown} onChange={handleChange} data={data} />
                        <CustomDropDown label="Is this a one time plan ?" name="isOneTimePlan" options={yesNoOptions} onChange={handleChange} data={data} />
                        {data?.isOneTimePlan && (
                            <>
                                <CustomInputDropDown
                                    name="reavailableAfter"
                                    options={[
                                        { name: 'Week', value: 'WEEK' },
                                        { name: 'Month', value: 'MONTH' },
                                        { name: 'Year', value: 'YEAR' },
                                    ]}
                                    data={data}
                                    onChange={handleChange}
                                    required
                                />
                            </>
                        )}
                        <CustomInputDropDown
                            name="freezingTerm"
                            label={'Freezing Term (per year)'}
                            options={[
                                { name: 'Week', value: 'WEEK' },
                                { name: 'Month', value: 'MONTH' },
                                { name: 'Year', value: 'YEAR' },
                            ]}
                            data={data}
                            onChange={handleChange}
                        />
                        <CustomInputDropDown
                            name="cancellingTerm"
                            label={'Cancelling Term (per year)'}
                            options={[
                                { name: 'Week', value: 'WEEK' },
                                { name: 'Month', value: 'MONTH' },
                                { name: 'Year', value: 'YEAR' },
                            ]}
                            data={data}
                            onChange={handleChange}
                        />
                        <CustomMultiSelectEditable
                            data={data}
                            name="services"
                            options={catalogServiceFilterItems.map((item) => ({
                                ...item,
                                value: item._id,
                            }))}
                            onChange={handleChange}
                            editableFields={['defaultQuantity', 'netPrice']}
                            showFields={['upc']}
                        />
                        <CustomInputSwitch name="isActive" data={data} onChange={handleChange} col={4} />
                    </CustomGridLayout>
                </CustomCard>
                <CustomCard col="12" title="Assessed Fees">
                    <CustomPickList name="assessedFee" selected={data?.assessedFee} sourceData={allAssessedFeesDropdown} onPickListChange={handleChange} />
                </CustomCard>

                <CustomCard col="12" title="Contract Options">
                    <CustomGridLayout>
                        <CustomDropDown name="autoPay" options={autoPayOptions} onChange={handleChange} data={data} />
                        {data?.autoPay === 'ON_SET_SCHEDULE' && (
                            <CustomDropDown
                                name="howOftenWillClientsBeCharged"
                                label="How Often will Clients Be Charged"
                                options={oftenClientChargedOptions}
                                onChange={handleChange}
                                data={data}
                            />
                        )}
                        {data?.autoPay && (
                            <>
                                <CustomDropDown name="interval" options={intervalOptions} onChange={handleChange} data={data} col="2" />
                                <CustomInputNumber name="timePeriod" data={data} onChange={handleChange} col="2" suffix={data?.interval} />
                            </>
                        )}
                        {data?.howOftenWillClientsBeCharged === 'NO_OF_AUTOPAYS' && (
                            <CustomInput name="noOfAutopays" label="Number of AutoPays" data={data} onChange={handleChange} col="4" keyfilter="int" />
                        )}

                        {data?.autoPay === 'ON_SET_SCHEDULE' && (
                            <>
                                <CustomDropDown
                                    name="whenWillClientsBeCharged"
                                    label="When will Clients Be Charged"
                                    options={whenClientChargedOptions}
                                    onChange={handleChange}
                                    data={data}
                                />
                                {data?.whenWillClientsBeCharged === 'SPECIFIC_DATE' && <CustomCalenderInput name="date" data={data} onChange={handleChange} />}
                                {data?.howOftenWillClientsBeCharged === 'NO_OF_AUTOPAYS' && (
                                    <CustomDropDown
                                        name="whatHappensAfterAutopayPayments"
                                        label={` What happens after ${data?.noOfAutopays} payments`}
                                        options={afterSixPaymentsOptions}
                                        onChange={handleChange}
                                        data={data}
                                    />
                                )}
                            </>
                        )}

                        <>
                            <CustomDropDown name="sellOnline" options={yesNoOptions} onChange={handleChange} data={data} />
                            {data?.sellOnline && <CustomEditor name="onlineDescription" onTextChange={handleChange} data={data} />}
                        </>
                    </CustomGridLayout>
                </CustomCard>

                <CustomButtonGroup>
                    <PrimaryButton label="Save" className="mx-2" onClick={handleSave} loading={loading} />
                    <LightButton label="Cancel" onClick={() => history.goBack()} />
                </CustomButtonGroup>
            </FormPage>
        </>
    );
};

export default AgreementPlanForm;
